import script from "./CommentSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentSection.vue?vue&type=script&lang=ts&setup=true"

import "./CommentSection.vue?vue&type=style&index=0&id=49a230a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a230a7"]])

export default __exports__